import React from "react";
import styles from "./static-page.scss";

export default function StaticPage({ children }) {
  return <div className={styles["static-page"]}>{children}</div>;
}
